import { render, staticRenderFns } from "./ticketDetailDrawer.vue?vue&type=template&id=38b6ebf1&scoped=true"
import script from "./ticketDetailDrawer.vue?vue&type=script&lang=js"
export * from "./ticketDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./ticketDetailDrawer.vue?vue&type=style&index=0&id=38b6ebf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b6ebf1",
  null
  
)

export default component.exports